import { Calendar, Receipt } from '@gravity-ui/icons'
import { CardTitle } from '@heroui/react'
import { AnimatePresence,motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

import { Card, CardContent, CardHeader } from '@/components/ui/Card'
import { EmptyState } from '@/components/ui/EmptyState'
import { useAnalyticsStore } from '@/store/analytics.store'

import { AnalyticsExpenseRow } from './AnalyticsExpenseRow'

export function AnalyticsExpenseList() {
  const { t } = useTranslation()
  const { reportItems, selectedDate } = useAnalyticsStore()

  const filteredItems = selectedDate
    ? reportItems.filter(item => item.date.startsWith(selectedDate))
    : []

  return (
    <Card className="h-full flex flex-col">
      <CardHeader>
        <CardTitle>
          {selectedDate
            ? t('analytics.expenses_on', { defaultValue: 'Expenses on {{date}}', date: selectedDate })
            : t('analytics.select_day', { defaultValue: 'Select a day on the heatmap' })}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1 overflow-y-auto relative">
        <AnimatePresence mode="wait">
          {!selectedDate ? (
            <motion.div
              key="empty-select"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.1 }}
            >
              <EmptyState
                icon={<Calendar className="size-8" />}
                title={t('analytics.select_day', { defaultValue: 'Select a day on the heatmap' })}
                description={t('analytics.click_heatmap_hint', { defaultValue: 'Click any tile on the heatmap to view expenses for that day.' })}
              />
            </motion.div>
          ) : filteredItems.length === 0 ? (
            <motion.div
              key="empty-none"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.1 }}
            >
              <EmptyState
                icon={<Receipt className="size-8" />}
                title={t('analytics.no_expenses', { defaultValue: 'No expenses recorded for this day.' })}
                description={''}
              />
            </motion.div>
          ) : (
            <motion.div
              key="list"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="space-y-2"
            >
              <AnimatePresence mode="popLayout">
                {filteredItems.map((item, index) => (
                  <motion.div
                    key={item.id}
                    layout
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    transition={{ duration: 0.1, delay: index * 0.025 }}
                  >
                    <AnalyticsExpenseRow item={item} />
                  </motion.div>
                ))}
              </AnimatePresence>
            </motion.div>
          )}
        </AnimatePresence>
      </CardContent>
    </Card>
  )
}
